// removed by extract-text-webpack-plugin
module.exports = {"visible-xs":"visible-xs___BNdAX","visible-sm":"visible-sm___3EyBZ","visible-md":"visible-md___HHZc5","visible-lg":"visible-lg___1iLkd","row":"row___Llu5M","hidden-xs":"hidden-xs___2r4YE","hidden-sm":"hidden-sm___BcVqm","hidden-md":"hidden-md___CyZ17","hidden-lg":"hidden-lg___2fG1b","page":"page___W10LO padding-top-4___1TrZL","main":"main___2ewnF","title":"title___3x5p4 h1___3_4RF","small-title":"small-title___1F-ZH h2___hzLuT","h3":"h3___2M4XA h3___5u0xZ"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Companies/Companies.css
// module id = 867
// module chunks = 0